import React, { useState } from 'react';
import { Typography } from '@naf-simba/building-blocks-typography';
import { Button } from '@naf-simba/elements-buttons';
import { Loader } from '@naf-simba/building-blocks-loaders';
import { breakpoints } from '@naf/theme';
import { useMediaQuery } from '../../../../../../../hooks/useMediaQuery';
import * as S from './SearchForm.styles';

interface SearchFormProps {
  isLoading: boolean;
  hasError: boolean;
  onLookup: (licensePlate: string) => void;
}

export const SearchForm = ({ isLoading, hasError, onLookup }: SearchFormProps) => {
  const [licensePlate, setLicensePlate] = useState<string>();
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.m})`);

  const handleSearch = () => {
    if (licensePlate) {
      onLookup(licensePlate);
    }
  };

  return (
    <>
      <S.Title variant="headlineXXS">Når må bilen til EU-kontroll?</S.Title>
      <S.StyledLabel htmlFor="registrationNumber">Registreringsnummer</S.StyledLabel>
      <S.Search>
        <S.SearchInput
          placeholder="Søk etter kjøretøy"
          id="registrationNumber"
          type="text"
          onChange={(number: string) => setLicensePlate(number)}
          onKeyUp={(e: KeyboardEvent) => {
            if (e.key === 'Enter') handleSearch();
          }}
        />
        <Button
          type="button"
          color="secondary"
          size={isMobile ? 'small' : 'medium'}
          isLoading={isLoading}
          onClick={handleSearch}
        >
          Sjekk
        </Button>
      </S.Search>
      {isLoading && (
        <S.SpinnerWrapper>
          <Loader />
        </S.SpinnerWrapper>
      )}
      {hasError && !isLoading && (
        <S.ErrorMessage>
          <Typography>Vi klarte ikke å finne kjøretøyet. Sjekk om registreringsnummeret stemmer.</Typography>
        </S.ErrorMessage>
      )}
    </>
  );
};
